import React, { useState, useEffect, useContext } from 'react';

// import data
import { MernProjects, ReactProjects, projectsData } from '../data';

// import components
import Project from './Project';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { ThemeContext } from '../context/ThemeContext';


const Projects = () => {

  const { Theme } = useContext(ThemeContext)
  return (
    <div>

      <Tabs variant='soft-rounded' align='center' >
        {/* All Tabs Navigation */}
        <TabList mb="5" >
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: 'red.400' }} >All</Tab>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: 'red.400' }}>React</Tab>
          <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: 'red.400' }}>MERN</Tab>
        </TabList>
        <TabPanels>
          {/* All Projects */}
          <TabPanel>
            <section className='grid gap-y-12 lg:grid-cols-2 lg:gap-x-20 lg:gap-y-8 w-100%'>

              {projectsData.map((item) => {
                return <Project item={item} key={item.id} />;
              })}
            </section>
          </TabPanel>
          <TabPanel>
            <section className='grid gap-y-12 lg:grid-cols-2 lg:gap-x-20 lg:gap-y-8 w-100%'>
              {ReactProjects.map((item) => {
                return <Project item={item} key={item.id} />;
              })}
            </section>
          </TabPanel>
          <TabPanel>
            <section className='grid gap-y-12 lg:grid-cols-2 lg:gap-x-20 lg:gap-y-8 w-100%'>
              {MernProjects.map((item) => {
                return <Project item={item} key={item.id} />;
              })}
            </section>
          </TabPanel>
        </TabPanels>
      </Tabs>


    </div>
  );
};




export default Projects;
